@if(inputForm && hrKey && enKey && itKey && siKey && srKey && bsKey && defaultLanguageCode){
<div>
  <ng-container *transloco="let t">
    <form [formGroup]="inputForm">
      @if(selectedLanguage === 'hr'){
      <div>
        <div class="d-flex align-items-center justify-content-between">
          <label for="{{hrKey}}">{{ t(hrLabel ?? "") }}
            @if(inputForm.controls[hrKey].errors?.['required']){
            <span>*</span>
            }
          </label>
          <ng-container *ngTemplateOutlet="languageInputSwitcherTemplate"></ng-container>
        </div>
        @if(isInput){
        <input type="text" id="{{hrKey}}" class="form-control" [formControlName]="hrKey" name="{{hrKey}}"
          placeholder='{{t(hrLabel ?? "")}}' />
        }
       @if(!isInput && !isRichText){
          <textarea type="text" class="form-control" id="{{hrKey}}" [formControlName]="hrKey" name="{{hrKey}}"
                  rows="3"></textarea>
        }
        @if(inputForm.controls[hrKey].touched && !isRichText){
        <div>
          @for(errorMessage of inputForm.controls[hrKey].errors | errorMessages:hrKey; track errorMessage){
          <span class="errorMes pt-1">{{ errorMessage }}</span>
          }
        </div>
        }
      </div>
      }
      @if(selectedLanguage === 'en'){
      <div>
        <div class="d-flex align-items-center justify-content-between">
          <label for="{{enKey}}">{{ t(enLabel ?? "") }}
            @if(inputForm.controls[enKey].errors?.['required']){
            <span>*</span>
            }
          </label>
          <ng-container *ngTemplateOutlet="languageInputSwitcherTemplate"></ng-container>
        </div>
        @if (isInput){
        <input type="text" id="{{enKey}}" class="form-control" [formControlName]="enKey" name="{{enKey}}"
          placeholder='{{t(enLabel ?? "")}}' />
        }
          @if(!isInput && !isRichText){
          <textarea type="text" class="form-control" id="{{enKey}}" [formControlName]="enKey" name="{{enKey}}"
            rows="3"></textarea>
        }
        @if(inputForm.controls[enKey].touched && !isRichText){
        <div>
          @for(errorMessage of inputForm.controls[enKey].errors | errorMessages:enKey; track errorMessage){
          <span class="errorMes pt-1">{{ errorMessage }}</span>
          }
        </div>
        }
      </div>
      }
      @if(selectedLanguage === 'it'){
      <div>
        <div class="d-flex align-items-center justify-content-between">
          <label for="{{itKey}}">{{ t(itLabel ?? "") }}
            @if(inputForm.controls[itKey].errors?.['required']){
            <span>*</span>
            }
          </label>
          <ng-container *ngTemplateOutlet="languageInputSwitcherTemplate"></ng-container>
        </div>
        @if(isInput){
        <input type="text" id="{{itKey}}" class="form-control" [formControlName]="itKey" name="{{itKey}}"
          placeholder='{{t(itLabel ?? "")}}' />
        }
        @if(!isInput && !isRichText){
          <textarea type="text" class="form-control" id="{{itKey}}" [formControlName]="itKey" name="{{itKey}}"
          rows="3"></textarea>
        }
        @if(inputForm.controls[itKey].touched && !isRichText){
        <div>
          @for(errorMessage of inputForm.controls[itKey].errors | errorMessages:itKey; track errorMessage){
          <span class="errorMes pt-1">{{ errorMessage }}</span>
          }
        </div>
        }
      </div>
      }
      @if(selectedLanguage === 'slo'){
      <div>
        <div class="d-flex align-items-center justify-content-between">
          <label for="{{siKey}}">{{ t(siLabel ?? "") }}
            @if(inputForm.controls[siKey].errors?.['required']){
            <span>*</span>
            }
          </label>
          <ng-container *ngTemplateOutlet="languageInputSwitcherTemplate"></ng-container>
        </div>
        @if(isInput){
        <input type="text" id="{{siKey}}" class="form-control" [formControlName]="siKey" name="{{siKey}}"
          placeholder='{{t(siLabel ?? "")}}' />
        }
          @if(!isInput && !isRichText){
            <textarea type="text" class="form-control" id="{{siKey}}" [formControlName]="siKey" name="{{siKey}}"
                rows="3"></textarea>
            }
        @if(inputForm.controls[siKey].touched && !isRichText) {
        <div>
          @for(errorMessage of inputForm.controls[siKey].errors | errorMessages:siKey; track errorMessage){
          <span class="errorMes pt-1">{{ errorMessage }}</span>
          }
        </div>
        }
      </div>
      }
    @if(selectedLanguage === 'bs'){
      <div>
        <div class="d-flex align-items-center justify-content-between">
          <label for="{{bsKey}}">{{ t(bsLabel ?? "") }}
            @if(inputForm.controls[bsKey].errors?.['required']){
            <span>*</span>
            }
          </label>
          <ng-container *ngTemplateOutlet="languageInputSwitcherTemplate"></ng-container>
        </div>
        @if(isInput){
        <input type="text" id="{{bsKey}}" class="form-control" [formControlName]="bsKey" name="{{bsKey}}"
          placeholder='{{t(bsLabel ?? "")}}' />
        }
          @if(!isInput && !isRichText){
            <textarea type="text" class="form-control" id="{{bsKey}}" [formControlName]="bsKey" name="{{bsKey}}"
                rows="3"></textarea>
            }
        @if(inputForm.controls[bsKey].touched && !isRichText) {
        <div>
          @for(errorMessage of inputForm.controls[bsKey].errors | errorMessages:bsKey; track errorMessage){
          <span class="errorMes pt-1">{{ errorMessage }}</span>
          }
        </div>
        }
      </div>
      }
  @if(selectedLanguage === 'sr'){
    <div>
    <div class="d-flex align-items-center justify-content-between">
    <label for="{{srKey}}">{{ t(srLabel ?? "") }}
      @if(inputForm.controls[srKey].errors?.['required']){
      <span>*</span>
      }
    </label>
    <ng-container *ngTemplateOutlet="languageInputSwitcherTemplate"></ng-container>
  </div>
    @if(isInput){
      <input type="text" id="{{srKey}}" class="form-control" [formControlName]="srKey" name="{{srKey}}"
          placeholder='{{t(srLabel ?? "")}}' />
    }
    @if(!isInput && !isRichText){
        <textarea type="text" class="form-control" id="{{srKey}}" [formControlName]="srKey" name="{{srKey}}"
          rows="3"></textarea>
          }
     @if(inputForm.controls[srKey].touched) {
      <div>
        @for(errorMessage of inputForm.controls[srKey].errors | errorMessages:srKey; track errorMessage){
        <span class="errorMes pt-1">{{ errorMessage }}</span>
        }
      </div>
      }
      </div>
      }
      <ng-template #languageInputSwitcherTemplate>
        <app-language-input-switcher (languageSelected)="setLanguage($event)" [defaultLanguage]="defaultLanguageCode"
          [isHrFilled]="!!inputForm.controls[hrKey].value" [isEnFilled]="!!inputForm.controls[enKey].value"
          [isItFilled]="!!inputForm.controls[itKey].value" [isSrFilled]="!!inputForm.controls[srKey].value"
          [isSloFilled]="!!inputForm.controls[siKey].value" [isBsFilled]="!!inputForm.controls[bsKey].value"
          [selectedLanguage]="selectedLanguage" [isHrRequired]="inputForm.controls[hrKey].errors?.['required']"
          [isEnRequired]="inputForm.controls[enKey].errors?.['required']"
          [isItRequired]="inputForm.controls[itKey].errors?.['required']"
          [isSrRequired]="inputForm.controls[srKey].errors?.['required']"
          [isBsRequired]="inputForm.controls[bsKey].errors?.['required']"
          [isSloRequired]="inputForm.controls[siKey].errors?.['required']">
        </app-language-input-switcher>
      </ng-template>
          @if(!isInput && isRichText){
          <app-rich-text-editor-wrapper (contentChange)="richTextChange($event)" [key]="selectedLanguage" [disabled]="disabled"
              [content]="richTextContent"/>
          }
      </form>
    </ng-container>
  </div>
}
